import JwtDecode from 'jwt-decode'

export default class Account {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new Account(obj)
    } catch (_) {
      return null
    }
  }

  constructor ({ account_id, role, email, firstname, lastname, profile_img, dealer }) {
    this.id = account_id // eslint-disable-line camelcase
    this.role = role
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.profile_img = profile_img
    this.dealer = dealer
  }

  mayNavigate () {
    switch (this.role) {
      case 'accounting':
        return false
      case 'sales':
        return true
      case 'expert':
        return true
      case 'admin':
        return true
      case 'user':
          return true
      default:
        return false
    }
  }

  isAdmin(){
    return this.hasRole('admin') 
  }

  isUser(){
    return this.hasRole('user') 
  }

  isSales(){
    return this.hasRole('sales') 
  }

  isAccounting(){
    return this.hasRole('accounting') 
  }

  isExpert(){
    return this.hasRole('expert') 
  }

  hasRole(role){
    if(this.role == 'admin'){
      return true
    }
    

    if(this.role == role){
      return true
    }
    return false
  }

  get isAdmin () {
    return this.role
  }
}
